import {
  useHtzAhuComponentCatalogShowActiveCatalogQuery,
  useHtzAhuComponentCatalogShowQuery,
} from "@/services/backend/htz/ahu/api/ahu-component-catalog-api";

/**
 * useActiveAhuComponentCatalog loads the catalog of air handling unit components which is active for the company.
 * The catalog is undefined while it loads or when the company has no active
 * catalog.
 */
export function useActiveAhuComponentCatalog(companyId: string) {
  const {
    data: activeCatalog,
    isLoading: activeCatalogIsLoading,
    error: activeCatalogError,
  } = useHtzAhuComponentCatalogShowActiveCatalogQuery(
    { companyId },
    { skip: !companyId },
  );

  const {
    data: catalog,
    isLoading: catalogIsLoading,
    error: catalogError,
  } = useHtzAhuComponentCatalogShowQuery(
    { id: activeCatalog?.catalogId ?? "" },
    {
      skip: activeCatalog === undefined || activeCatalog.catalogId === null,
    },
  );

  return {
    data: catalog,
    isLoading: activeCatalogIsLoading || catalogIsLoading,
    error: activeCatalogError || catalogError,
  };
}
